import { useEffect } from 'react';
import { getAggregateRatingSchema } from '@/config/reviews';

const LocalBusinessSchema = () => {
  useEffect(() => {
    const aggregateRating = getAggregateRatingSchema();
    const schema = {
      "@context": "https://schema.org",
      "@type": "MedicalClinic",
      "@id": "https://physiowrld.rs/#clinic",
      "name": "PHYSIOWRLD",
      "description": "Specijalizovana fizikalna terapija i rehabilitacija na Novom Beogradu. Stručni fizioterapeuti i savremene metode lečenja.",
      "url": "https://physiowrld.rs",
      "telephone": "+381605037477",
      "email": "info@physiowrld.rs",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Omladinskih brigada 96E/4",
        "addressLocality": "Novi Beograd",
        "addressRegion": "Beograd",
        "postalCode": "11070",
        "addressCountry": "RS"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "44.8187721",
        "longitude": "20.3974697"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "08:00",
          "closes": "20:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "09:00",
          "closes": "15:00"
        }
      ],
      "priceRange": "$$",
      "image": "https://physiowrld.rs/images/physiowrld-logo.webp",
      // Rating markup is emitted ONLY when the real Google review numbers are
      // configured in src/config/reviews.ts (Google policy: no invented counts).
      ...(aggregateRating ? { aggregateRating } : {}),
      "sameAs": [
        "https://www.facebook.com/share/19X4S9QEjy",
        "https://www.instagram.com/physiowrld"
      ],
      "areaServed": {
        "@type": "City",
        "name": "Novi Beograd"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Usluge fizikalne terapije",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Fizikalna terapija",
              "description": "Elektroterapija, ultrazvuk i manuelne tehnike za brži oporavak"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Kineziterapija",
              "description": "Individualno vođene vežbe za jačanje i pokretljivost"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Kiropraktika",
              "description": "Manualna terapija kičme i zglobova"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Laser terapija",
              "description": "Visokoenergijska laser terapija za bol i upalu"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Terapeutska masaža",
              "description": "Sportske i rehabilitacione masaže"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Rehabilitacija",
              "description": "Fizikalna rehabilitacija posle povreda i operacija"
            }
          }
        ]
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    script.id = 'local-business-schema';
    
    const existing = document.getElementById('local-business-schema');
    if (existing) {
      existing.remove();
    }
    
    document.head.appendChild(script);

    return () => {
      const schemaScript = document.getElementById('local-business-schema');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return null;
};

export default LocalBusinessSchema;
